import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import Icon from '../icon';

@Component
export default class XTh extends Vue {

  @Prop({type: String, required: false}) readonly prop!: string;
  @Prop({type: Boolean, required: false, default: true}) readonly sortable!: boolean;
  @Prop({type: Function, required: false, default: v => v}) readonly lblFn!: (v: any) => string ;

  get sortValue() {
    return (this.$parent as any).sortState;
  }

  get isActive() {
    return this.sortValue && this.sortValue.prop === this.prop;
  }

  onCycleSort() {
    if (this.sortable) {
      (this.$parent as any).onSortTh(this.prop, this.lblFn);
    }
  }

  render() {
    let classes = ["x-th"];
    this.sortable && classes.push("is-sortable is-clickable");
    this.isActive && classes.push(`sort-${this.sortValue.order}`);

    return (
      <th class={classes.join(" ")}
        onClick={this.onCycleSort}>
        {this.$slots.default}
        {this.sortable && (
        <span class="sort-icon">
          {this.isActive && {
            asc: <Icon icon="angle-down" class="icon is-small info"/>,
            desc: <Icon icon="angle-up" class="icon is-small info"/>
          }[this.sortValue.order]}
        </span>
        )}
      </th>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-a139ba3a/x-th.tsx" });